"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ConfigurationTriangle(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12.464 3c.563 0 1.126.263 1.441.788l8.797 14.634c.65 1.078-.183 2.549-1.44 2.549H3.664c-1.259 0-2.088-1.471-1.439-2.55l8.797-14.633c.315-.525.878-.788 1.441-.788zm0 2.27l-8.236 13.7H20.7l-8.236-13.7zm.748 5.201c.104 0 .19.077.202.18l.094.81c.387.133.737.338 1.04.6l.75-.325a.202.202 0 0 1 .255.086l.75 1.297a.202.202 0 0 1-.055.264l-.645.48a3.116 3.116 0 0 1 0 1.215l.645.481a.2.2 0 0 1 .055.263l-.75 1.297a.202.202 0 0 1-.255.086l-.75-.325a3.157 3.157 0 0 1-1.04.601l-.094.81a.203.203 0 0 1-.202.18h-1.496a.203.203 0 0 1-.202-.18l-.094-.81a3.14 3.14 0 0 1-1.04-.6l-.75.322a.2.2 0 0 1-.255-.084l-.75-1.297a.2.2 0 0 1 .055-.263l.645-.48a3.116 3.116 0 0 1 0-1.216l-.645-.48a.202.202 0 0 1-.055-.264l.75-1.297a.202.202 0 0 1 .255-.086l.75.325a3.175 3.175 0 0 1 1.04-.6l.094-.81a.203.203 0 0 1 .202-.18zm-.748 2.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = ConfigurationTriangle;
